import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";

const Duplicates = () => {
  const [duplicates, setDuplicates] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState("");
  const [deleting, setDeleting] = useState(false);

  const fetchDuplicates = async () => {
    try {
      setLoading(true);
      const { ok, data, total } = await api.post("/bank/duplicates", { source });
      if (!ok) return toast.error("Error fetching duplicates");
      setDuplicates(data);
      setTotal(total);
    } catch (error) {
      toast.error("Error fetching duplicates");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBank = async (bank) => {
    try {
      if (!confirm("Are you sure you want to delete this bank?")) return;
      setDeleting(true);
      const { ok, data } = await api.remove(`/bank/${bank._id}`);
      if (!ok) throw new Error("Error while deleting bank");
      toast.success("Bank deleted");
      fetchDuplicates();
    } catch (error) {
      console.log(error);
      toast.error("Error while deleting bank");
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    fetchDuplicates();
  }, [source]);

  return (
    <div className="max-w-6xl mx-auto p-4">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-medium text-gray-800">{total} Potential Duplicate Transactions</h1>
        <select
          value={source}
          onChange={(e) => setSource(e.target.value)}
          className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-sm text-gray-700 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors">
          <option value="">All Sources</option>
          <option value="BUNQ">BUNQ</option>
          <option value="BNP">BNP</option>
          <option value="BUNQ_LESTUD">BUNQ LESTUD</option>
        </select>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-32">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="space-y-4">
          {duplicates.map((group, groupIndex) => (
            <div key={groupIndex} className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
              <div className="px-4 py-3 border-b border-gray-100">
                <h3 className="text-sm font-medium text-gray-700">
                  Group {groupIndex + 1} • Source ID: {group[0].source_payment_id}
                </h3>
              </div>
              <div className="divide-y divide-gray-100">
                {group.map((transaction) => (
                  <div key={transaction._id} className="px-4 py-2 hover:bg-gray-50 transition-colors">
                    <div className="flex items-center gap-6 text-sm">
                      <div className="w-24 text-gray-500">{new Date(transaction.date).toLocaleDateString()}</div>
                      <div className="w-24 font-medium text-gray-900">{transaction.amount}</div>
                      <div className="flex-1 text-gray-900 truncate">{transaction.description}</div>
                      <div className="w-20 text-gray-900">{transaction.source}</div>
                      <div className="w-24">
                        <span
                          className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                            transaction.status === "completed"
                              ? "bg-green-100 text-green-800"
                              : transaction.status === "pending"
                              ? "bg-yellow-100 text-yellow-800"
                              : "bg-gray-100 text-gray-800"
                          }`}>
                          {transaction.status}
                        </span>
                      </div>
                      <div className="w-32 text-gray-900 truncate">{transaction.category}</div>
                      <Link target="_blank" to={`/bank?bank_id=${transaction._id}`}>
                        <button className="px-2 py-1 bg-blue-500 text-white rounded-md text-sm">View</button>
                      </Link>
                      <div className="flex justify-start items-end">
                        <button className="btn red-btn disabled:opacity-50" onClick={() => handleDeleteBank(transaction)} disabled={deleting}>
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          {duplicates.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500 text-sm">No potential duplicates found</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Duplicates;
